import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class LoanDetailsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        page: 1,
      },
      openDrawer: false,
    };

    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
    // search fields
    this.pendingFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
    ];
    this.activeLoansFields = [
      // {
      //   name: "customerName",
      //   label: "Name",
      //   type: "text",
      //   placeholder: "Customer Name",
      // },
      // {
      //   name: "mobileNumber",
      //   label: "Phone Number",
      //   type: "text",
      //   placeholder: "Phone Number",
      // },
      // {
      //   name: "pan",
      //   label: "PAN Number",
      //   type: "text",
      //   placeholder: "PAN Number",
      // },
      // {
      //   name: "loanAccountNumber",
      //   label: "Loan Account Number",
      //   type: "text",
      //   placeholder: "Loan Account Number",
      // },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ACTIVE_LOAN_SEARCH_OPTIONS,
        placeholder: "Status",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        placeholder: "End Date",
      },
    ];
    this.closedLoansFields = [
      // {
      //   name: "customerName",
      //   label: "Name",
      //   type: "text",
      //   placeholder: "Customer Name",
      // },
      // {
      //   name: "mobileNumber",
      //   label: "Phone Number",
      //   type: "text",
      //   placeholder: "Phone Number",
      // },
      // {
      //   name: "pan",
      //   label: "PAN Number",
      //   type: "text",
      //   placeholder: "PAN Number",
      // },
      // {
      //   name: "loanAccountNumber",
      //   label: "Loan Account Number",
      //   type: "text",
      //   placeholder: "Loan Account Number",
      // },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ACTIVE_LOAN_SEARCH_OPTIONS,
        placeholder: "Status",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        placeholder: "End Date",
      },
    ];
    this.settlementsLoansFields = [
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ACTIVE_LOAN_SEARCH_OPTIONS,
        placeholder: "Status",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        placeholder: "End Date",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let {
      isAdmin,
      pendingFields,
      activeLoansFields,
      closedLoansFields,
      settlementsLoansFields,
    } = this;
    let { activeKey } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        {activeKey !== "pendingrestructure" && (
          <button
            type="button"
            className="btn filter_modal_btn"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
            <i class="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
        )}
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          {...(activeKey === "pending"
            ? {
                fields: pendingFields,
              }
            : activeKey === "active"
            ? {
                fields: activeLoansFields,
              }
            : activeKey === "closed"
            ? {
                fields: closedLoansFields,
              }
            : activeKey === "loansettlements"
            ? {
                fields: settlementsLoansFields,
              }
            : { fields: [] })}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(LoanDetailsSearch);
